import { ChangeDetectorRef, Component, Input, OnChanges, OnInit, inject } from '@angular/core';
import { ConstructAPI } from 'src/app/API/constructAPI';
import { RestApiService } from 'src/app/API/restapi';
import { UploadImageComponent } from 'src/app/Images/upload-image/upload-image.component';
import { Enums } from 'src/app/Shared/enums';
import { SharedService } from 'src/app/Shared/shared-service.service';
import { Customer } from 'src/model/customer.model';
import { FileInterface } from 'src/model/file.interface';
import { FileService } from 'src/services/file.service';

@Component({
    selector: 'app-customer-album',
    templateUrl: './customer-album.component.html',
    styleUrls: ['./customer-album.component.scss'],
    standalone: false
})

export class CustomerAlbumComponent implements OnInit, OnChanges {
  private restApi = inject(RestApiService);
  private constructApi = inject(ConstructAPI);
  private cdr = inject(ChangeDetectorRef);
  private fileService = inject(FileService);
  protected enums = inject(Enums);
  protected sharedService = inject(SharedService);

  normalFileArr: FileInterface[] = [];
  supportingDocArr: FileInterface[] = [];
  contactDocsArr: FileInterface[] = [];
  loanDocsArr: FileInterface[] = [];
  accountDocsArr: FileInterface[] = [];
  formJDocArr: FileInterface[] = [];

  @Input() viewCustomer: Customer;

  isContactCollapsed = true;
  isLoanCollapsed = true;
  isAccountCollapsed = true;
  isFormJCollapsed = true;

  ngOnInit() {

    // this.getAllPictures();
  }

  ngOnChanges() {
    if (this.normalFileArr.length > 0)
      this.normalFileArr.splice(0, this.normalFileArr.length);
    if (this.supportingDocArr.length > 0)
      this.supportingDocArr.splice(0, this.supportingDocArr.length);
    if (this.contactDocsArr.length > 0)
      this.contactDocsArr.splice(0, this.contactDocsArr.length);
    if (this.loanDocsArr.length > 0)
      this.loanDocsArr.splice(0, this.loanDocsArr.length);
    if (this.accountDocsArr.length > 0)
      this.accountDocsArr.splice(0, this.accountDocsArr.length);
    if (this.formJDocArr.length > 0)
      this.formJDocArr.splice(0, this.formJDocArr.length);

    this.getAllFiles();
  }

  private async getAllFiles() {
    const files = await this.fileService.getFiles(this.constructApi.getAllFiles(this.viewCustomer.ID));
    for (const file of files) {
      if (file.label.includes("contact"))
        this.contactDocsArr.push(file);
      else if (file.label.includes("formj"))
        this.formJDocArr.push(file);
      else if (file.label.includes("application-form") || file.label.includes("epf-statement") ||
        file.label.includes("consent-form")
        || file.label.includes("reference-form") || file.label.includes("ic/front/")
        || file.label.includes("ic/back") || file.label.includes("payslip") || file.label.includes("bank-statement") || file.label.includes("atm-card") || file.label.includes("epf-proof") || file.label.includes("acknowledgement"))
        this.supportingDocArr.push(file);

      else if (file.label.includes("loan"))
        this.loanDocsArr.push(file);
      else if (file.label.includes("account/"))
        this.accountDocsArr.push(file);
      else
        this.normalFileArr.push(file);
    }
    this.supportingDocArr.sort((a, b) => (a.contentType > b.contentType && a.lastModified > b.lastModified) ? -1 : 1);
    this.contactDocsArr.sort((a, b) => (a.contentType > b.contentType && a.lastModified > b.lastModified) ? -1 : 1);
    this.normalFileArr.sort((a, b) => (a.contentType > b.contentType && a.lastModified > b.lastModified) ? -1 : 1);
    this.loanDocsArr.sort((a, b) => (a.contentType > b.contentType && a.lastModified > b.lastModified) ? -1 : 1);
    this.accountDocsArr.sort((a, b) => (a.contentType > b.contentType && a.lastModified > b.lastModified) ? -1 : 1);

    // const xhttp = this.restApi.getRequest(this.constructApi.getAllFiles(this.viewCustomer.ID));
    // xhttp.onreadystatechange = () => {
    //   if (xhttp.readyState == 4 && xhttp.status == 200) {
    //     const jsonArray = JSON.parse((xhttp.responseText));

    //     jsonArray.forEach(json => {

    //       const lastModifiedDate = (json["Last-Modified"] == undefined) ? json["Last-Modified"] : new Date(json["Last-Modified"]);
    //       const file = { label: json.Name, url: json.Data, contentType: json["Content-Type"], lastModified: lastModifiedDate, uploadedBy: json.uploadedBy }

    //       // if (file.contentType.includes("image/") == false) {
    //       //   this.fileArr.push(file)
    //       // }
    //       // else {
    //       if (file.label.includes("contact"))
    //         this.contactDocsArr.push(file);

    //       else if (file.label.includes("formj"))
    //         this.formJDocArr.push(file);
    //       else if (file.label.includes("application-form") || file.label.includes("epf-statement") ||
    //         file.label.includes("consent-form")
    //         || file.label.includes("reference-form") || file.label.includes("ic/front/")
    //         || file.label.includes("ic/back") || file.label.includes("payslip") || file.label.includes("bank-statement") || file.label.includes("atm-card") || file.label.includes("epf-proof") || file.label.includes("acknowledgement"))
    //         this.supportingDocArr.push(file);

    //       else if (file.label.includes("loan"))
    //         this.loanDocsArr.push(file);
    //       else if (file.label.includes("account/"))
    //         this.accountDocsArr.push(file);
    //       else
    //         this.normalFileArr.push(file);
    //       // }

    //     }
    //     );

    //     this.supportingDocArr.sort((a, b) => (a.contentType > b.contentType && a.lastModified > b.lastModified) ? -1 : 1);
    //     this.contactDocsArr.sort((a, b) => (a.contentType > b.contentType && a.lastModified > b.lastModified) ? -1 : 1);
    //     this.normalFileArr.sort((a, b) => (a.contentType > b.contentType && a.lastModified > b.lastModified) ? -1 : 1);
    //     this.loanDocsArr.sort((a, b) => (a.contentType > b.contentType && a.lastModified > b.lastModified) ? -1 : 1);
    //     this.accountDocsArr.sort((a, b) => (a.contentType > b.contentType && a.lastModified > b.lastModified) ? -1 : 1);
    //   }
    // };

  }

  openImageModal(supportingDocType: string) {
    const modalRef = this.sharedService.openModal(UploadImageComponent);

    modalRef.componentInstance.selectedCustomerId = this.viewCustomer.ID;
    modalRef.componentInstance.supportingDocType = supportingDocType;
    //get added loan
    modalRef.componentInstance.passEntry.subscribe((entry) => {

      this.normalFileArr.splice(0, this.normalFileArr.length)
      this.supportingDocArr.splice(0, this.supportingDocArr.length)
      this.contactDocsArr.splice(0, this.contactDocsArr.length)
      this.loanDocsArr.splice(0, this.loanDocsArr.length)
      this.accountDocsArr.splice(0, this.accountDocsArr.length)
      this.getAllFiles();
    });

    modalRef.result.then(() => {
      //detect changes
      this.cdr.detectChanges();
    })
  }

}
